/**
 * Allinea la lingua dell'app alla preferenza salvata sul profilo
 * (`users.lingua`): chi la sceglie su un telefono la ritrova sul PC.
 *
 * Il cambio lingua ricarica la pagina: per non entrare in un giro di
 * ricariche (profilo vecchio nello store che dice "it", telefono che dice
 * "en"...) si prova UNA volta per sessione e per lingua.
 */

import { useEffect } from "react";
import { useAuthStore } from "../lib/auth-store";
import { impostaLingua, linguaCorrente } from "./index";

export const CHIAVE_SYNC_LINGUA = "fs-lingua-sync";

export function SincronizzaLingua() {
  const lingua = useAuthStore((s) => s.user?.lingua);
  useEffect(() => {
    if (!(lingua === "it" || lingua === "en") || lingua === linguaCorrente()) return;
    let gia: string | null = null;
    try {
      gia = sessionStorage.getItem(CHIAVE_SYNC_LINGUA);
    } catch {
      /* sessionStorage non disponibile */
    }
    if (gia === lingua) return;
    try {
      sessionStorage.setItem(CHIAVE_SYNC_LINGUA, lingua);
    } catch {
      /* ignora */
    }
    impostaLingua(lingua);
  }, [lingua]);
  return null;
}
